const images = {
    logo: require('./images/logo.png'),
    user: require('./images/user.png'),
    JESUS: require('./images/jesus.jpg'),
    noDataFound: require('./images/no-data.jpg'),
};

export default images;
